<template>
	<div class="animated fadeIn">
		<div class="row">
			<div class="col-12">
				<b-card>
					<form id="container__form" @submit.prevent="save">
						<tooltip label="map title" placement="right">
							<input
								name="title"
								v-model="record.title"
								v-validate="'required'"
								:class="{'form-control': true, 'is-invalid': errors.has('title')}"
								type="text"
							/>
							<span
								v-show="errors.has('title')"
								class="help invalid-feedback"
							>{{ $t(errors.first('title')) }}</span>
						</tooltip>
					</form>
				</b-card>
			</div>
			<ButtonSubmit />
		</div>
	</div>
</template>
<script>
	import axios from 'axios'
	import {ButtonSubmit} from '../../components'

	export default {
		name: 'mapsForm',
		components: {
			ButtonSubmit
		},
		data() {
			return {
				record_id: 0,
				record: {
					title: ''
				},
			}
		},
		methods: {
			save(e) {
				e = e || window.event
				e.preventDefault()
				this.$validator.validateAll().then((result) => {
					if (result) {
						this.$root.loader = true
						axios
							.post(`/maps/${this.record_id}`, this.record)
							.then((response) => {
								this.$root.loader = false
								if (response.data.status === 1) {
									this.$router.push(`/maps/${response.data.data._id}`)
								}
							})
					} else {
						// invalid
						this.$root.loader = false
					}
				})
			},
			fetchData() {
				if (this.record_id != 0) {
					this.$root.loader = true
					axios
						.get(`/maps/${this.record_id}`)
						.then((response) => {
							this.$root.loader = false
							console.log(response);
							if (response.data.status === 1) {
								this.record = response.data.data
							}
						})
				}
			}
		},

		mounted() {
			this.record_id = this.$route.params.id
			this.fetchData()
		},
	}
</script>
